import { useSnackbar } from 'notistack';

import { axios } from 'lib';
import { useMutation } from 'react-query';

const addCompaniesToDirect = ({ directID, companies_ids, company_type }) => {
  return axios.post(
    `/api/directs/${directID}/companies`,
    JSON.stringify({
      direct_id: +directID,
      companies_ids,
      company_type
    })
  );
};

export const useAddCompaniesToDirect = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: addCompaniesToDirect,
    onSuccess: () => {
      enqueueSnackbar('Companies successfully added to a direct', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
